import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  color: {
    desktop: 'var(--color-primary)',
  },
  maxStock: 100,
  minStock: 20,
  decreaseOnSubsequentVisits: false,
  animateBar: false,
  labels: {
    before: "Only",
    after: "left in stock!"
  },
}
